import STORE from '@/store'
import GLOBAL from '@/utils/global.js'
import {MessageBox} from "element-ui"
import { Message } from 'element-ui';

function getOrderListByStatus(orderStatus) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/getOrderListByStatus", orderStatus)
      .then((res) => {
        let data = dealOrderList(res.data)
        resolve(data);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("getOrderListByStatus failed: ", orderStatus);
        }
        reject(error);
      });
  });
}

function dealOrderList(data) {
  let orderList = [];
  for (let i = 0; i < data.data.list.length; i++) {
    let order = {};
    // 合并地址信息
    let addressDetail = data.data.list[i].addressDistrict + "-" + data.data.list[i].addressWard + "-" + data.data.list[i].addressBed;
    let addressTotal = data.data.list[i].addressCampus + "-" + addressDetail;
    order.addressDetail = addressDetail;
    order.addressTotal = addressTotal;

    order.note=data.data.list[i].note;
    order.discountAmount = data.data.list[i].discountAmount;

    order.addressMobile = data.data.list[i].addressMobile;
    order.addressName = data.data.list[i].addressName;

    //新增的地址备注
    order.addressNote = data.data.list[i].addressNote;

    // 时间格式转换
    order.createdTime = transTime(data.data.list[i].createdTime);

    order.id = data.data.list[i].id;

    order.itemInfo = data.data.list[i].itemInfo;
    for (let j = 0; j < order.itemInfo.length; j++) {
      order.itemInfo[j].price = order.itemInfo[j].price.toFixed(2);
      order.itemInfo[j].totalPrice = order.itemInfo[j].totalPrice.toFixed(2);
    }

    order.totalAmount = data.data.list[i].totalAmount;
    order.totalPrice = data.data.list[i].totalPrice;
    order.totalPrice = order.totalPrice.toFixed(2);

    //增加log
    order.log = data.data.list[i].log;
    for (let j = 0; j < order.log.length; j++) {
      order.log[j].createdTime = transTime(order.log[j].createdTime)
    }

    //满减活动
    order.promotionDetail = data.data.list[i].promotionDetail;

    orderList.push(order);
  }
  let pageData = {
    currentPage: 1,
    pageSize: data.data.pageSize,
    totalSize: data.data.totalCount,
  };
  return {
    orderList: orderList,
    pageData: pageData,
  };
}

function confirmOrderByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/confirmOrderByID", orderID)
      .then((res) => {
        resolve(res);
        console.log('--订单确认--');
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("confirmOrderByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function deliverOrderByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/deliverOrderByID", orderID)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("deliverOrderByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function serveOrderByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/serveOrderByID", orderID)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("serveOrderByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function acceptRefundByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/acceptRefundByID", orderID)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("acceptRefundByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function refuseRefundByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/refuseRefundByID", orderID)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("refuseRefundByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function cancelOrderByID(orderID) {
  return new Promise((resolve, reject) => {
    STORE
      .dispatch("Data/cancelOrderByID", orderID)
      .then((res) => {
        console.log('--订单取消--');
        resolve(res);
      })
      .catch((error) => {
        if (GLOBAL.debugMode) {
          console.log("cancelOrderByID failed: ", orderID);
        }
        reject(error);
      });
  });
}

function transTime(time) {
  let zoneDate = new Date(time).toJSON();
  let date = new Date(+new Date(zoneDate) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '');
  return date;
}

function deleteItemFromArray(val, array) {
  let index = array.indexOf(val);
  if (index > -1) {
    if (array.length == 1) {
      array = [];
    }
    else {
      array.splice(index, 1);
    }
  }
  return array;
}

//判断当前处理订单的实际状态（有些订单可能已经是其他状态，此时应限制用户操作
function judgeOrderStatus(orderId, status, isBatchFlag){
  return new Promise((resolve, reject) => {
    STORE.dispatch('Data/getStatusById', {orderId: orderId})
        .then((res) => {
          console.log('当前订单状态：',res.data.data);
          if(status !== res.data.data && !isBatchFlag){
            MessageBox.alert(`当前订单状态是：${res.data.data}，无法操作。`, '提醒', {
              confirmButtonText: '确定',
              type: 'warning',
              callback: () => {
                Message.warning({
                  type: 'warning',
                  message: '操作已取消'
                });
              }
            });
          }
          resolve(res);
        })
        .catch((err) => {
          if (GLOBAL.debugMode) {
            console.log("judgeOrderStatus failed: ", orderId, err);
          }
          reject(err);
        })
  })
}

export default {
  getOrderListByStatus,
  confirmOrderByID,
  deliverOrderByID,
  serveOrderByID,
  acceptRefundByID,
  refuseRefundByID,
  cancelOrderByID,
  transTime,
  deleteItemFromArray,
  judgeOrderStatus,
}
